const genAnswer = function (qu, value) {
  const currOption = qu.optionList.find(item => item.optionName == value)
  const selTags = currOption.tags ? currOption.tags.filter(item => (item.selected === 1)) : []

  // 搜集标签name
  qu.selectedTags = selTags

  return [{
    descId: qu.id,
    answer: value,
    optionTitle: currOption.originTitle,
    otherAnswer: qu.answerConfig.satisfactionCommentLabel === '1' ? JSON.stringify({
      tags: selTags.map(item => ({
        id: item.keyId,
        tagValue: item.tagValue,
      })),
      otherTag: qu.otherTag
    }) : JSON.stringify({
      tags: [],
      otherTag: ''
    })
  }]
}

const setAnswer = function (qu) {
  this.value = qu.answerList.length ? qu.answerList[0].answer : ''
  if (qu.answerList.length && qu.answerList[0].otherAnswer) {
    this.otherAnswer = JSON.parse(qu.answerList[0].otherAnswer)
    this.otherTag = this.otherAnswer.otherTag

    const {tags} = this.otherAnswer
    if (tags && tags.length) {
      this.selectedTags = tags.map(item => ({
        id: item.quScoreTagId,
        tagValue: item.tagValue
      }))

      tags.forEach(tagItem => {
        qu.optionList.forEach(optionItem => {
          if (optionItem.tags) {
            optionItem.tags.forEach(subItem => {
              if (subItem.keyId == tagItem.quScoreTagId) {
                subItem.selected = 1
              }
            })
          }
        })
      })
    }
  }
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer


// WEBPACK FOOTER //
// ./src/components/editor/SatisfactionBox/answer.js